module.exports = __webpack_public_path__ + "img/9.a69d98a8.jpg";